/*=========================================================================================
  File Name: modulePackageManagementActions.js
  Description: Package Module Actions
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchPackages({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_PREFIX + "/packages")
        .then((response) => {
          commit('SET_PACKAGES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(process.env.VUE_APP_PREFIX + `/packages/${data.id}`, data.packages)
        .then((response) => {
          commit('UPDATE_PACKAGE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updatePackage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_PREFIX + `/labels/refresh`, data)
        .then((response) => {
          console.log(response);
          Object.values(response.data)
                .map(x => x.package)
                .forEach(x => {
                  console.log(x);
                  commit('UPDATE_PACKAGE', x)
                });
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  registerLabels({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_PREFIX + `/labels/pdf/${data}`)
        .then((response) => {
          console.log(response);
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  syncPackages({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_PREFIX + "/packages/sync")
        .then((response) => {
          // console.log(response);
          commit('SYNC_PACKAGES')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  }


}
